/* eslint-disable import/prefer-default-export, no-underscore-dangle */
import { create } from 'zustand';
import { nanoid } from 'nanoid';

export const style1 = 'logo-max text-dark-deep border-b border-white/10 bg-transparent';
export const style2 = 'logo-min bg-purple-7/90 backdrop-blur-lg text-white';

const useZusHomeStore = create((set, get) => ({
  headerBackground: '',
  extWebpJpg: 'webp',
  initCall: ({ comefrom }) => {
    if (get().called) return null;
    return null;
  },
  setHeaderBackground2: (style) => set((state) => {
    // console.log('state.noFixedHeader', state.noFixedHeader, style);
    const styles = {
      style1,
      style2,
      classDefault: state.classDefault,
    };

    let styleFinal = '';
    if (style === 'classDefault') styleFinal += styles.classDefault;
    else if (!style || !styles[style]) styleFinal += styles.style1;
    else styleFinal += styles[style];
    // console.log('state.noFixedHeader', style, state.noFixedHeader);
    if (!state.noFixedHeader) styleFinal += ' fixed ';
    return {
 ...state, headerBackground: styleFinal, called: nanoid(), styleBk: style,
};
  }),
}));

export const isInit = () => !!useZusHomeStore.getState()?._initFromApp;

export function initData(initDataData) {
  const initFromApp = useZusHomeStore.getState()?._initFromApp;
  if (initFromApp) return null;
  useZusHomeStore.setState({
    ...initDataData,
    _initFromApp: true,
  });
  return null;
}

export {
  useZusHomeStore,
};

export default useZusHomeStore;
